import App from '@crochik/pi-react/application/App';
import { Default } from '@crochik/pi-react/context';
import { toJS } from 'mobx';
import API from '../services/API';

export default function createLead() {
    const lead = toJS(Default.state.get('form.Contact'));
    console.log(lead);

    API().createLead(lead)
        .then(lead => {
            console.log('lead added', lead);
            App().selectPage('Calendar');
        })
        .catch(e => {
            alert('error creating lead');
        });
}


// WEBPACK FOOTER //
// ./src/app/actions/CreateLead.ts